export default (languageCode: string) => /* GraphQL */ `
mutation RemoveInspirations($ids: [ID!]!) {
  inspirations: removeInspirations(ids: $ids languageCode: "${languageCode}") {
      id
      shortId
      url
      slug
  }
}`;
